import React from 'react';
import { Breakpoints, Container, ContainerPadding, CTA, styled } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import { FocusLayerSizeV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import { PortalContext } from '../../context/PortalContext';
import { AlertType } from '../alerts/alerts-type';
import { VWBookParticipa } from './promotions/VWBook26/vwBookParticipa';
import { LaLigaParticipa } from './promotions/laLiga/laLigaParticipa';
import { ElClasicoParticipa } from './promotions/elClasico/el-clasico-participa';

const CTAStyled = styled(CTA)`
	color: #00b0f0;
	width: 32px;
	height: 32px;

	& svg {
		width: 32px;
		height: 32px;
	}
`;

export const PromotionPopupLayer: React.FC<{
	alertType: AlertType | null;
	isPromotionPopupVisible: boolean;
	setIsPromotionPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
	promotionLayerRef: React.RefObject<HTMLElement>;
}> = ({ alertType, isPromotionPopupVisible, setIsPromotionPopupVisible, promotionLayerRef }) => {
	const { layerManager } = React.useContext(PortalContext);
	const portalContext = React.useContext(PortalContext);

	const handleClose = () => {
		setIsPromotionPopupVisible(false);
		if (promotionLayerRef?.current) {
			(promotionLayerRef.current as any).close();
			return ((promotionLayerRef.current as any) = null);
		}
		return;
	};

	const renderPromotionLayer = () => (
		<PortalContext.Provider value={portalContext}>
			<Container
				horizontalAlign={'flex-end'}
				padding={{
					top: ContainerPadding.dynamic0100,
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b1600]: ContainerPadding.dynamic0100,
					},
					bottom: ContainerPadding.dynamic0100,
				}}
			>
				<CTAStyled
					tag="button"
					emphasis="tertiary"
					onClick={handleClose}
					aria-label="Close pop-up"
					icon={<Close variant="small" aria-hidden />}
				/>
			</Container>
			{(() => {
				switch (alertType) {
					case AlertType.VWBook26_Participa:
						return <VWBookParticipa />;
					case AlertType.LaLiga26_Open:
						return <LaLigaParticipa />;
					case AlertType.ElClasico26_Open:
						return <ElClasicoParticipa />;
					default:
						return <></>;
				}
			})()}
		</PortalContext.Provider>
	);

	React.useEffect(() => {
		let layer: any;
		if (promotionLayerRef.current) {
			(promotionLayerRef.current as any).close();
			(promotionLayerRef.current as any) = null;
		}

		// Usar isPromotionPopupVisible para controlar la apertura
		if (isPromotionPopupVisible) {
			layer = layerManager.openFocusLayer(
				renderPromotionLayer,
				{},
				{
					size: FocusLayerSizeV2.A,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			(promotionLayerRef.current as any) = layer;
		}

		return () => {
			if (layer) {
				layer.close();
				(promotionLayerRef.current as any) = null;
			}
		};
	}, [layerManager, promotionLayerRef, portalContext, isPromotionPopupVisible]);

	return null;
};
